module.exports = __webpack_public_path__ + "static/media/BANKNIFTY_F1.f796ca05.txt";